import React, { useEffect, useRef } from 'react';
import { Addons } from '../../Addons/Addons';

const ChooseAddon = (props) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!props.isDisable) {
      if (ref.current) {
        const offsetTop = ref.current.offsetTop;
        window.scrollTo({top: offsetTop, behavior: 'smooth' });
      }
    }
  }, [props.isDisable]);

  return (
    <div ref={ref} className={`choosing-cellular-addon ${props.isDisable ? 'disabled' : ''}`}>
         {props.isDisable && <div className='disabled'></div>}
         <h2 className='title'>תוכלו לקבל הרבה יותר מהנייד שלכם באמצעות השירותים הנוספים שלנו</h2>
         <Addons addons={props.addons}  selectedAddOns={props.selectedAddOns} updateStore={props.updateStore} flowType={props.flowType} saleType={props.saleType} />
    </div>
  );
};

export default ChooseAddon;
